import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
export { app, analytics } from './firebase-analytics';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { SnackbarProvider } from './components/snackbar';
import AuthProvider from 'hooks/useAuthContext';
import ProgressBar from 'components/progress-bar';

import { useEffect } from 'react';

import { OnboardingProvider } from 'contexts/OnboardingContext';

import SocialSignInHandler from './components/common/SocialSignInHandler';
import ExternalJobRedirectHandler from './components/common/ExternalJobRedirectHandler';


/**
 * App
 *
 * Top level component that wraps the entire application.
 *
 * Handles the following:
 * - Sets up the routing using BrowserRouter
 * - Provides the context for the auth provider
 * - Provides the context for the theme provider
 * - Provides the context for the snackbar provider
 * - Renders the main routes
 * - Renders the progress bar
 * - Renders the scroll to top button
 * - Renders the chart component
 * - Renders the social sign in handler
 */
export default function App() {
  useEffect(() => {
    // createPDF();
  })
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <OnboardingProvider>
              <ThemeProvider>
                <SnackbarProvider>
                  <ProgressBar />
                  <ScrollToTop />
                  <StyledChart />
                  <SocialSignInHandler />
                  <ExternalJobRedirectHandler/>
                  <Router />
                </SnackbarProvider>
              </ThemeProvider>
            </OnboardingProvider>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </LocalizationProvider>
  );
}
